import { PLAN_CREATION_FAILURE_REASONS } from "./constants";

const KNOWN_REASONS = new Set(Object.values(PLAN_CREATION_FAILURE_REASONS));

// Collect response bodies from interceptor shape (err.data) and raw axios
// shape (err.response.data). Each is wrapped in try/catch to handle getters
// that throw under unusual proxy/test configurations.
const getBodies = (err) => {
  const bodies = [];

  try {
    bodies.push(err.data);
  } catch {
    // ignore
  }

  try {
    bodies.push(err.response?.data);
  } catch {
    // ignore
  }

  return bodies.filter(Boolean);
};

const firstString = (values) => {
  for (const v of values) {
    if (typeof v === "string" && v.length > 0) {
      return v;
    }
  }
};

// Never throws. Unknown shapes map to { reason: "unknown" }.
export const parsePlanCreationError = (error) => {
  if (!error || typeof error !== "object") {
    return { reason: PLAN_CREATION_FAILURE_REASONS.unknown };
  }

  const bodies = getBodies(error);

  const rawReason = firstString(
    bodies.flatMap((b) => [b.detail?.reason, b.error?.reason, b.reason]),
  );
  const message = firstString([
    ...bodies.flatMap((b) => [b.error?.message, b.message]),
    typeof error.message === "string" ? error.message : undefined,
  ]);
  const status = error.status ?? error.response?.status;

  const reason = KNOWN_REASONS.has(rawReason)
    ? rawReason
    : PLAN_CREATION_FAILURE_REASONS.unknown;

  return { reason, rawReason, message, status };
};
